module.exports = __webpack_public_path__ + "e3f5b1763ecc4d443dc14846222b1918.png";